/* Mister Gift : encart « 2 achetés = 3ᵉ offert » (snippets/promo-header-cart.liquid)
 * Mis à jour via les événements panier du thème (pas de MutationObserver ni d'appel réseau).
 * Les encarts réinjectés avec le tiroir panier s'initialisent seuls (custom element). */
(() => {
  if (customElements.get('mg-offer')) return;

  const instances = new Set();

  // Même périmètre que la remise automatique : collection « all » (hors versions numériques et cartes cadeaux)
  const eligibleCount = (cart) => {
    if (!cart) return null;
    if (!Array.isArray(cart.items)) return typeof cart.item_count === 'number' ? cart.item_count : null;
    return cart.items.reduce((total, item) => {
      const excluded = item.gift_card || !(item.original_price > 0) || /numérique/i.test(item.product_title || '');
      return excluded ? total : total + item.quantity;
    }, 0);
  };

  const update = (cart) => {
    const eligible = eligibleCount(cart);
    if (eligible === null) return;
    instances.forEach((el) => el.render(eligible));
  };

  document.addEventListener('cart:updated', (event) => update(event.detail?.cart));

  const subscribe = () => {
    const pubsub = window.FoxTheme?.pubsub;
    if (!pubsub) return false;
    pubsub.subscribe(pubsub.PUB_SUB_EVENTS.cartUpdate, (data) => update(data?.cart));
    return true;
  };
  if (!subscribe()) document.addEventListener('DOMContentLoaded', subscribe, { once: true });

  class MgOffer extends HTMLElement {
    connectedCallback() {
      this.group = Number(this.dataset.group) || 3;
      this.titleEl = this.querySelector('[data-title]');
      this.detailEl = this.querySelector('[data-detail-text]');
      this.fillEl = this.querySelector('.mg-offer__fill');
      this.eligible = Number(this.dataset.eligible) || 0;
      instances.add(this);
    }

    disconnectedCallback() {
      instances.delete(this);
    }

    render(eligible) {
      if (eligible === this.eligible) return;
      this.eligible = eligible;

      const inGroup = eligible % this.group;
      const unlocked = Math.floor(eligible / this.group);
      const missing = inGroup === 0 ? this.group : this.group - inGroup;
      const justUnlocked = unlocked > 0 && missing === this.group;

      let title;
      if (eligible === 0) title = 'Achetez-en 2, le 3ᵉ est offert';
      else if (justUnlocked) title = unlocked > 1 ? `Bravo ! ${unlocked} articles offerts` : 'Bravo ! Votre 3ᵉ article est offert';
      else if (missing === 1) title = 'Plus qu’un article pour obtenir le 3ᵉ offert';
      else title = `Plus que ${missing} articles pour obtenir le 3ᵉ offert`;

      if (this.titleEl) this.titleEl.textContent = title;
      if (this.detailEl) this.detailEl.textContent = justUnlocked ? this.dataset.detailUnlocked : this.dataset.detail;
      if (this.fillEl) this.fillEl.style.width = `${justUnlocked ? 100 : Math.max((inGroup / this.group) * 100, 6)}%`;
    }
  }

  customElements.define('mg-offer', MgOffer);
})();
